<template>
	<div>
		<ExpensesTabs
			:tab="'Finance'"
			@tab="onTabChange($event)"			
		/>
		<ListFinance
			:color="color" 
			:currencies="currencies"
			@row-click="onRowClick($event)"
		/>
	</div>
</template>
<script>
import ListFinance from "@/views/expenses/finance/list_finance.vue";
import ExpensesTabs from "@/views/expenses/commond/expenses_tabs";

export default {
	name: 'Finance',
	components: {
		ListFinance,
		ExpensesTabs
	},
	data() {
		return {
			color: this.$attrs.color ? this.$attrs.color : '#FFB946',
			currencies: [],
		}
	},
	created() {
		this.listCountries();
		this.update_breadcrumb();
	},
	methods: {
		listCountries() {
			const url = `/api/config/country`;

			return axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const currencies_by_id = new Map();

							data.forEach(country => {
								if (!country.currency) return;

								const { currency, ...country_details } = country;
								if (!currencies_by_id.has(currency.id)) {
									currencies_by_id.set(currency.id, Object.assign({}, currency, {
										countries: []
									}));
								}

								currencies_by_id.get(currency.id).countries.push(country_details);
							});

							this.currencies = Array.from(currencies_by_id.values());
						}
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		update_breadcrumb() {
			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: 'Finance',
				to: '/expenses/finance'
			});
		},
		onTabChange(current_tab) {
			this.$router.push({ name: current_tab });
		},
		onRowClick(claim) {
			this.$router.push({ name: 'Finance Claim', params: { id: claim.id } });
		},
	}
}
</script>